import React from "react";
import { FieldRenderProps } from "react-final-form";
import { FormFieldProps, Form, Label, Dropdown } from "semantic-ui-react";

interface IProps extends FieldRenderProps<any, any>, FormFieldProps {}

const SelectInputOnChange: React.FC<IProps> = ({
  input,
  width,
  options,
  placeholder,
  search,
  defaultValue,
  onChange = () => {},
  disabled,
  meta: { touched, error },
}) => {
  const handleChange = (e: any, data: any) => {
    input.onChange(data.value);
    onChange(input, data.value);
  };

  return (
    <Form.Field error={touched && !!error} width={width}>
      <Dropdown
        fluid
        search={search}
        selection
        disabled={disabled}
        defaultValue={defaultValue}
        value={input.value}
        onChange={handleChange}
        placeholder={placeholder}
        options={options}
      />
      {touched && error && (
        <Label basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default SelectInputOnChange;
